import React, { FC } from 'react';
import styled from 'styled-components';
import { WindowWidthContext } from '@minecraft.utils';
import Icon from '@minecraft.icon';
import { media } from '@minecraft.themes';
import { DrawerProps } from '../shared/types';
import { useDrawerToggle, useDrawerToggleCategory } from '../shared/hooks';
import { iconSize } from '../shared/styles';

const DrawerHeaderContainer = styled.div`
  align-items: center;
  border-bottom: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};
  display: flex;
  padding: 0.5rem 0.625rem;
  justify-content: flex-end;
`;

const DrawerHeaderTitle = styled.div`
  font-weight: 600;
  margin: auto;
`;

export const BackIcon = styled(Icon)`
  ${iconSize}
  cursor: pointer;
  margin-right: 0.625rem;

  ${media.sm`
    display: none;
  `}
`;

export const CloseIcon = styled(Icon)`
  ${iconSize}
  justify-self: flex-end;
  cursor: pointer;
`;

interface Props {
  title: DrawerProps['title'];
  submitClick: DrawerProps['submitClick'];
}

const DrawerHeader: FC<Props> = ({ title, submitClick }) => {
  const { lessSm } = WindowWidthContext.useWidthData();

  const { toggleDrawer } = useDrawerToggle();
  const { activeCategory, toggleCategory } = useDrawerToggleCategory();

  const handleClick = (): void => {
    submitClick();
    toggleDrawer();
  };

  const isBackIconVisible = lessSm && activeCategory.value;
  const isTitleVisible = (title && !activeCategory.value) || !lessSm;
  const isCategoryLabelVisible = lessSm && activeCategory.value;

  return (
    <DrawerHeaderContainer data-testid="drawer-header-wrapper">
      {isBackIconVisible && (
        <BackIcon inheritColor name="back-2" onClick={(): void => toggleCategory(activeCategory)} />
      )}
      {isTitleVisible && <DrawerHeaderTitle>{title}</DrawerHeaderTitle>}
      {isCategoryLabelVisible && <DrawerHeaderTitle>{activeCategory.label}</DrawerHeaderTitle>}
      <CloseIcon inheritColor name="close" onClick={handleClick} />
    </DrawerHeaderContainer>
  );
};

export default DrawerHeader;
